import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromCatalogPlan from './reducers/catalog-plan.reducer';
import { EffectsModule } from '@ngrx/effects';
import { CatalogPlanEffects } from './effects/catalog-plan.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromCatalogPlan.catalogPlanFeatureKey, fromCatalogPlan.reducer),
    EffectsModule.forFeature([CatalogPlanEffects]),
  ],
})
export class CatalogPlanStoreModule {}
